import React, { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  getPatternContextForPreviewPath,
  getPatternCopyPromptPath,
} from "../../../config/pattern-helpers";
import { cn } from "../../../lib/utils";

import { PressIcon } from "./icons/PressIcon";
import { ShapesIcon } from "./icons/ShapesIcon";

export const PatternUseToolbarButton: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const patternContext = useMemo(
    () => getPatternContextForPreviewPath(location.pathname),
    [location.pathname]
  );

  if (!patternContext) {
    return null;
  }

  const copyPromptPath = getPatternCopyPromptPath(
    patternContext.category,
    patternContext.pattern.id
  );

  return (
    <button
      type="button"
      onClick={() => history.push(copyPromptPath)}
      title="Copy pattern prompt"
      className={cn(
        "flex h-9 w-9 items-center justify-center rounded-lg transition-colors",
        location.pathname === copyPromptPath
          ? "bg-[#00bc7d]/20 text-[#00d492]"
          : "text-[#999] hover:bg-[#00bc7d]/15 hover:text-[#00d492]"
      )}
    >
      <PressIcon>
        <ShapesIcon />
      </PressIcon>
    </button>
  );
};
